<nav class="navbar navbar-dark bg-dark">
  <div class="d-inline-flex flex-row h-100">
    <img class="p-0" src="assets/logo-eu.png"/>
    <img class="p-0" src="assets/logo-program.png"/>
    <div class="align-items-center text">
      Тази система е разработена по проект  BG16RFOP002-1.005-0326-C01 с  наименование „Разработване на система за ранно предизвестяване за природни бедствия Disaster alert“, финансиран от Оперативна програма „Иновации и конкурентоспособност“, съфинансирана от Европейския съюз чрез Европейския фонд за регионално развитие.
    </div>
  </div>
</nav>
